export function useFetchProductBySeoPath() {
  const { apiClient } = useShopwareContext()
  const product = ref(null)
  const loading = ref(false)
  const error = ref(null)

  const fetchProductBySeoPath = async (seoPath: string, options = {}) => {
    loading.value = true
    error.value = null

    try {
      const { data } = await apiClient.invoke(`product post /novu/headless/product/${seoPath}`, {
        body: {
          filter: [],
          associations: options.associations || {
            media: {},
            categories: {},
            seoUrls: {},
          },
          limit: 1, // Fetch only one product
        },
      })

      if (!data || !data.product) {
        throw new Error('No product found for the given SEO path.')
      }

      product.value = data.product
      product.value.customFieldLabels = data.custom_fields
      product.value.crossSellings = data.cross_sellings
    } catch (err) {
      error.value = err.message || 'Error fetching product.'
      console.error('Error fetching product by SEO path:', err)
    } finally {
      loading.value = false
    }
  }

  return {
    product,
    loading,
    error,
    fetchProductBySeoPath,
  }
}
